import { skipToken } from '@reduxjs/toolkit/query'
import { useFetchKolPlatformsQuery } from '@/api/workspace-api/kol-api'
import { type KolPlatform } from '@/types/schema/kol-schema'
import { PlatformShortcode } from '@/utils/convert-platform'

type UseKolPlatform = ({
  platform,
  kolId,
}: {
  platform?: PlatformShortcode
  kolId?: string
}) => {
  kolPlatformInfo?: KolPlatform
}

const useKolPlatform: UseKolPlatform = ({ platform, kolId }) => {
  const { data: kolPlatformsData } = useFetchKolPlatformsQuery(
    kolId
      ? {
          radar_uuid: kolId,
        }
      : skipToken,
  )

  return {
    kolPlatformInfo: kolPlatformsData?.platforms?.find(
      (kolPlatform) => kolPlatform.platform === platform,
    ),
  }
}

export default useKolPlatform
